import Swiper from 'swiper/bundle';

export default () => {

  let swiper = new Swiper('.timeline__slider-wrapper',{
    slidesPerView: 'auto',
    direction: 'horizontal',
    grabCursor: true,
    
    mousewheel: {
      forceToAxis: true,
    },
    
    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true,
    },
  })
}